<template lang="pug">

Card(
    :class="$style.root"
    radius="m"
    radius-side="all"
)
    AnimatedTransition(
        :class="$style.grow"
    )
        component( :is="stateName" :class="$style.grow" )

</template>

<script lang="ts">
import Vue, { computed, ref, useCssModule } from 'vue'

import { Card } from '@/shared/ui/Card'
import { Button } from '@/shared/ui/Button'
import { useAppStore } from '@/shared/model'
import AnimatedTransition from '@/shared/ui/transitions/AnimatedTransition/AnimatedTransition.vue'

import { IdleState } from './states/IdleState'
import { SuccessState } from './states/SuccessState'
import { ErrorState } from './states/ErrorState'
import { ExpiredLinkState } from './states/ExpiredLinkState'

export default Vue.extend({
    name: 'Content',
    setup() {
        const styles = useCssModule()
        const { state } = useAppStore()

        const componentRef = ref()
        const containerRef = ref()

        const stateName = computed(() => {
            switch (state.kind) {
                case 'idle':
                    return 'IdleState'
                case 'invalid-state':
                case 'expired':
                case 'api-fail':
                    return 'ExpiredLinkState'
                case 'resolved':
                    return 'SuccessState'
                case 'rejected':
                    return 'ErrorState'
                default:
                    return 'IdleState'
            }
        })

        return {
            componentRef,
            containerRef,
            state,
            stateName,
            styles,
        }
    },
    components: {
        AnimatedTransition,
        Card,
        Button,

        IdleState,
        SuccessState,
        ErrorState,
        ExpiredLinkState,
    },
})
</script>

<style module lang="scss" src="./Content.module.scss" />
